import '../../styles/locked-field.scss';
import {
    Button,
    FieldComponent,
    FieldFactoryProps,
    FieldRendererIntersectionProps,
    FieldType,
    RawFieldRenderer,
    StaticTextField,
} from 'forms';
import {Component} from 'react';
import React, {ReactNode} from 'react';

type Props<V, E extends HTMLElement, P extends object> =
    FieldRendererIntersectionProps<V, E> & P & ExtraProps<V, E, P>;

type FFProps<V, E extends HTMLElement, P extends object> =
    FieldFactoryProps<V, E> & ExtraProps<V, E, P>;

interface ExtraProps<V, E extends HTMLElement, P extends object> {
    Type: FieldType<V, E, P>;
    format?: (value: V) => ReactNode;
    overlayText?: string;
}

interface State {
    locked: boolean;
}

/**
 * Initially renders as static, but can be unlocked to become editable
 */
export default class LockedField<
    V,
    E extends HTMLElement,
    P extends object
> extends Component<Props<V, E, P>, State>
implements FieldComponent<V, E, State> {

    public state: State = {
        locked: true,
    };

    private handleUnlock = () => {
        this.setState({ locked: false });
    }

    public render() {
        const props = this.props;
        // @ts-ignore
        return <props.Renderer {...props} factory={this.factory} />;
    }

    private factory = ({
        format,
        Type,
        overlayText,
        ...props
    }: FFProps<V, E, P>) => {
        const state = this.state;
        return state.locked ? <div className="locked-field locked-field-locked">
            <StaticTextField value={props.value} format={format} />
            <div className="locked-field-overlay-container">
                {overlayText && <div className="locked-field-overlay">
                    {overlayText}
                </div>}
                <Button
                    icon="lock"
                    btn="warning"
                    className="btn-unlock btn-sm"
                    onClick={this.handleUnlock}
                    disabled={props.disabled}
                />
            </div>
        </div> : <div className="locked-field locked-field-unlocked">
            <Type {...(props as any)} Renderer={RawFieldRenderer} />
        </div>;
    }
}
